import React, { ReactNode, ErrorInfo } from 'react';
import ErrorFallback from './ErrorFallback';

interface ErrorBoundaryState {
  error: Error | null;
  componentStack: string | null;
  hasError: boolean;
}

class ErrorBoundary extends React.Component<{ children?: ReactNode }, ErrorBoundaryState> {
  constructor(props: { children?: ReactNode }) {
    super(props);
    this.state = { error: null, componentStack: null, hasError: false };
  }

  static getDerivedStateFromError(error: Error) {
    return { hasError: true, error };
  }

  override componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    this.setState({ componentStack: errorInfo?.componentStack ?? null });
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  override render() {
    if (this.state.hasError) {
      return <ErrorFallback error={this.state.error} componentStack={this.state.componentStack} />;
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
